import { courseHelpers } from 'Components/Card/Partials/Partials.Course';
import voucherHelpers from 'Components/Card/helper/voucherHelpers';

const scheduleCourseHelpers = {
    cardLinkBtnClass: courseHelpers.cardLinkBtnClass,
    showVoucher: (course) => !course.HasCourse && voucherHelpers.VoucherExpiresWithin30Days(course.VoucherExpirationDate),
    showEvent: (course) => course.HasCourse && course.HasUpcomingClass,
    showAudit: (course) => course.Taken && !course.Passed,
    showIncomplete: (course) => course.HasCourse && !course.HasUpcomingClass && !course.Taken,
    showComplete: (course) => course.Taken && course.Passed,
    showProgress: (course) => course.HasCourse && !course.Passed,
    getShowProperties: (course) => ({ 
        showVoucher: scheduleCourseHelpers.showVoucher(course),
        showEvent: scheduleCourseHelpers.showEvent(course),
        showComplete: scheduleCourseHelpers.showComplete(course),
        showIncomplete: scheduleCourseHelpers.showIncomplete(course),
        showAudit: scheduleCourseHelpers.showAudit(course),
        showProgress: scheduleCourseHelpers.showProgress(course)
    })
};

export default scheduleCourseHelpers;